import DOMPurify from 'dompurify'

const SANITIZE_CONFIG: DOMPurify.Config = {
  USE_PROFILES: { html: true, svg: true },
  ADD_TAGS: ['font', 'center'],
  ADD_ATTR: [
    'target',
    'data-blob',
    'data-ai-response',
    'data-email-image-placeholder',
  ],
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form'],
  ALLOW_UNKNOWN_PROTOCOLS: false,
}

/**
 * Strips executable HTML before the string is assigned to the DOM
 * (`dangerouslySetInnerHTML` / `innerHTML`).
 */
export const sanitizeHtmlContent = (
  dirty: string | null | undefined,
): string => {
  if (dirty == null || dirty === '') {
    return ''
  }
  return DOMPurify.sanitize(dirty, SANITIZE_CONFIG)
}
